import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="expandable-card"
export default class extends Controller {
  static targets = ["tray", "chevron"]
  static values = {
    expanded: { type: Boolean, default: false }
  }

  connect() {
    // Force tray to start collapsed
    this.trayTarget.style.maxHeight = "0"
    this.trayTarget.style.overflow = "hidden"
    this.trayTarget.style.opacity = "0"

    // Ensure chevron starts in normal position
    if (this.hasChevronTarget) {
      this.chevronTarget.style.transform = "rotate(0deg)"
    }
  }

  toggle(event) {
    // Prevent the link from navigating when clicking to expand
    event.preventDefault()
    event.stopPropagation()

    this.expandedValue = !this.expandedValue
  }

  expandedValueChanged() {
    if (this.expandedValue) {
      this.expand()
    } else {
      this.collapse()
    }
  }

  expand() {
    const tray = this.trayTarget

    // Get the natural height
    tray.style.maxHeight = "none"
    const height = tray.scrollHeight
    tray.style.maxHeight = "0"

    // Force reflow
    tray.offsetHeight

    // Animate to natural height
    tray.style.maxHeight = `${height}px`
    tray.style.overflow = "hidden"
    tray.style.opacity = "1"

    // Rotate chevron
    if (this.hasChevronTarget) {
      this.chevronTarget.style.transform = "rotate(90deg)"
    }

    // After animation, set to auto so content can resize
    setTimeout(() => {
      if (this.expandedValue) {
        tray.style.maxHeight = "none"
        tray.style.overflow = "visible"
      }
    }, 300) // Match CSS transition duration
  }

  collapse() {
    const tray = this.trayTarget

    // Set explicit height first
    tray.style.maxHeight = `${tray.scrollHeight}px`
    tray.style.overflow = "hidden"

    // Force reflow
    tray.offsetHeight

    // Animate to 0
    tray.style.maxHeight = "0"
    tray.style.opacity = "0"

    // Rotate chevron back
    if (this.hasChevronTarget) {
      this.chevronTarget.style.transform = "rotate(0deg)"
    }
  }
}
